import { PageDocument } from "prismicio-types";
import { HyamPrismicSliceZone } from "hyam-prismic/components";
import { styles as moduleStyles, HyamPrismicDocumentPageStyles } from "./styles";
import { withConfigure } from "hyam-core/utils/withConfigure";

type HyamPrismicDocumentPageProps = {
  page: PageDocument;
  styles?: Partial<HyamPrismicDocumentPageStyles>;
  stylesReplace?: Partial<HyamPrismicDocumentPageStyles>;
};

const _HyamPrismicDocumentPage = (props: HyamPrismicDocumentPageProps) => {
  if (!props?.page?.data?.slices) return <div>HyamPrismicDocumentPage: Empty page</div>;

  const { page } = props;
  const styles = props.styles as HyamPrismicDocumentPageStyles;

  return (
    <div className={styles.container}>
      <HyamPrismicSliceZone
        slices={page.data.slices}
        slicesStyles={{
          rich_text: {
            container: styles.slice_rich_text_container,
            content_container: styles.slice_rich_text_content_container,
          },
        }}
      />
    </div>
  );
};

export const HyamPrismicDocumentPage = withConfigure<
  HyamPrismicDocumentPageProps,
  HyamPrismicDocumentPageStyles
>({
  componentName: "HyamPrismicDocumentPage",
  Component: _HyamPrismicDocumentPage,
  moduleStyles,
});
